import React, { forwardRef } from 'react';
import Tooltip from '@material-ui/core/Tooltip';

const CustomTooltip = forwardRef((props, ref) => <Tooltip ref={ref} {...props} />);

export { CustomTooltip as Tooltip };
